import { aiContextRegistry } from '../AIContextRegistry';

aiContextRegistry.register({
  id: 'compte',
  label: 'Compte & Valorisation',
  description: 'Valorisation totale, TRI, performance',
  icon: '💰',
  tokens: ['$compte', '$valeur', '$tri'],
  parameterized: false,
  examples: [{ text: '@Claude mon $compte performe-t-il bien ?' }],
});
